<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="4">
        <el-input placeholder="工单编号" v-model="searchForm.installBillNo" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="工程师姓名" v-model="searchForm.engineerName" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="推荐人姓名" v-model="searchForm.referName" clearable></el-input>
      </el-col>
      <el-col :span="4">
        <el-select v-model="searchForm.status" placeholder="工单状态" clearable style="width: 100%">
          <el-option label="全部" value=""></el-option>
          <el-option label="待分配" :value="0"></el-option>
          <el-option label="已分配" :value="1"></el-option>
          <el-option label="进行中" :value="2"></el-option>
          <el-option label="已完成" :value="3"></el-option>
          <el-option label="已取消" :value="4"></el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-plus" @click="handleAdd">新增工单</el-button>
      </el-col>
    </el-row>

    <el-table 
      :data="tableData" 
      border 
      stripe 
      style="width: 100%"
      @expand-change="handleExpandChange"
    >
      <el-table-column type="expand" width="50">
        <template slot-scope="scope">
          <div class="log-list-container" v-loading="scope.row.logLoading">
            <div v-if="scope.row.logList && scope.row.logList.length > 0">
              <el-table :data="scope.row.logList" border size="small" style="width: 100%">
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <!-- 调整后的展开行顺序 -->
                <el-table-column prop="devId" label="设备ID" width="120"></el-table-column>
                <el-table-column prop="carNo" label="车牌号" width="140"></el-table-column>
                <el-table-column prop="romModel" label="设备型号" width="140"></el-table-column>
                <el-table-column prop="devicePic" label="设备图片" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.devicePic"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.devicePic" 
                      :preview-src-list="[logScope.row.devicePic]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="carPic" label="车牌图片" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.carPic"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.carPic" 
                      :preview-src-list="[logScope.row.carPic]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="position1" label="安装位置1" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.position1"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.position1" 
                      :preview-src-list="[logScope.row.position1]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="position2" label="安装位置2" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.position2"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.position2" 
                      :preview-src-list="[logScope.row.position2]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="position3" label="安装位置3" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.position3"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.position3" 
                      :preview-src-list="[logScope.row.position3]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="position4" label="安装位置4" width="150">
                  <template slot-scope="logScope">
                    <el-image 
                      v-if="logScope.row.position4"
                      style="width: 60px; height: 60px; cursor: pointer;" 
                      :src="logScope.row.position4" 
                      :preview-src-list="[logScope.row.position4]"
                      fit="contain">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-else class="empty-log">
              <el-empty description="暂无工单日志" :image-size="60"></el-empty>
            </div>
          </div>
        </template>
      </el-table-column>
      
      <!-- 调整后的主列表顺序 -->
      <el-table-column prop="installBillNo" label="工单编号" width="180"></el-table-column>
      <el-table-column prop="engineerName" label="安装师傅姓名" width="120"></el-table-column>
      <el-table-column prop="planCount" label="计划安装数量" width="120"></el-table-column>
      <el-table-column prop="planTime" label="安装时间" width="170"></el-table-column>
      <el-table-column prop="area" label="区域" width="150"></el-table-column>
      <el-table-column prop="address" label="安装详细地址" min-width="200" show-overflow-tooltip></el-table-column>
      
      <!-- 其他列保持不变 -->
      <el-table-column prop="batchCode" label="批次号" width="150"></el-table-column>
      <el-table-column prop="referName" label="推荐人" width="120"></el-table-column>
      <el-table-column prop="engineerPhone" label="工程师电话" width="130"></el-table-column>
      <el-table-column prop="realCount" label="实际数量" width="100"></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  name: 'InstallBillList',
  components: {
    Pagination
  },
  data() {
    return {
      searchForm: {
        installBillNo: '',
        engineerName: '',
        referName: '',
        status: ''
      },
      tableData: [],
      pagin: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表数据
    getList() {
      const params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize
      };
      
      // 添加搜索条件
      if (this.searchForm.installBillNo && this.searchForm.installBillNo.trim()) {
        params.installBillNo = this.searchForm.installBillNo;
      }
      if (this.searchForm.engineerName && this.searchForm.engineerName.trim()) {
        params.engineerName = this.searchForm.engineerName;
      }
      if (this.searchForm.referName && this.searchForm.referName.trim()) {
        params.referName = this.searchForm.referName;
      }
      if (this.searchForm.status !== '' && this.searchForm.status !== null && this.searchForm.status !== undefined) {
        params.status = this.searchForm.status;
      }
      
      this.$http.post('/manage/installBill/page', params)
        .then(res => {
          if (res.data.code === 0) {
            const records = res.data.data.records || [];
            // 为每条记录初始化logList和logLoading
            this.tableData = records.map(item => ({
              ...item,
              logList: null,
              logLoading: false
            }));
            this.pagin.total = res.data.data.total || 0;
          } else {
            this.$message.error(res.data.message || '获取数据失败');
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
        });
    },
    
    // 搜索
    search() {
      this.pagin.pageNum = 1;
      this.getList();
    },
    
    // 新增工单
    handleAdd() {
      this.$router.push('/install/bill/edit');
    },
    
    // 查看详情
    handleView(row) {
      this.$router.push({
        path: '/install/bill/detail',
        query: { installBillNo: row.installBillNo }
      });
    },
    
    // 编辑工单
    handleEdit(row) {
      this.$router.push({
        path: '/install/bill/edit',
        query: { installBillNo: row.installBillNo }
      });
    },
    
    // 删除工单
    handleDelete(row) {
      this.$confirm('确定删除该工单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.delete(`/manage/installBill/delete/${row.installBillNo}`)
          .then(res => {
            if (res.data.code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(res.data.message || '删除失败');
            }
          })
          .catch(err => {
            this.$message.error('删除失败');
            console.error(err);
          });
      }).catch(() => {});
    },
    
    // 获取状态文本
    getStatusText(status) {
      const statusMap = {
        0: '待分配',
        1: '已分配',
        2: '进行中',
        3: '已完成',
        4: '已取消'
      };
      return statusMap[status] || '未知';
    },
    
    // 获取状态标签类型
    getStatusType(status) {
      const typeMap = {
        0: 'info',
        1: '',
        2: 'warning',
        3: 'success',
        4: 'danger'
      };
      return typeMap[status] || 'info';
    },
    
    // 处理展开行变化
    handleExpandChange(row, expandedRows) {
      // 如果展开且还没有加载过logList，则调用接口获取
      if (expandedRows.includes(row) && !row.logList && !row.logLoading) {
        this.loadLogList(row);
      }
    },
    
    // 加载工单日志列表
    loadLogList(row) {
      row.logLoading = true;
      this.$http.post('/manage/installBill/detail', { installBillNo: row.installBillNo })
        .then(res => {
          if (res.data.code === 0) {
            row.logList = res.data.data.logList || [];
          } else {
            this.$message.error(res.data.message || '获取日志失败');
            row.logList = [];
          }
        })
        .catch(err => {
          this.$message.error('网络请求失败');
          console.error(err);
          row.logList = [];
        })
        .finally(() => {
          row.logLoading = false;
        });
    }
  }
};
</script>

<style scoped>
.search-add {
  margin-bottom: 20px;
}
.tableDel-Page {
  margin-top: 20px;
}
.log-list-container {
  padding: 20px;
  background-color: #f5f7fa;
}
.empty-log {
  padding: 20px 0;
  text-align: center;
}
</style>